import React, { useEffect, useState } from 'react';
import { cameraService } from '../../services/central-api/cameras';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex: number;
    labelFontSize?: number;
    required: boolean;
    disabled?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function AlertGroupsDropdown({ value, setValue, zIndex, labelFontSize, required, disabled = false, form, fieldName }: Props) {
    const [selectableAlertGroups, setSelectableAlertGroups] = useState<{ label: string; value: number; }[]>([]);

    async function getAlertGroups() {
        try {
            const alertGroups = await cameraService.getDropdownAlertGroups();
            setSelectableAlertGroups([
                ...alertGroups.map((alertGroup) => {
                    return {
                        value: alertGroup.id,
                        label: alertGroup.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getAlertGroups();
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('alertGroup')}
            items={selectableAlertGroups}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('alertGroup')}
            items={selectableAlertGroups}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelFontSize={labelFontSize}
            required={required}
            disabled={disabled}
        />;
    }
}

export default AlertGroupsDropdown;
